import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'

import { useProject } from './api/project'
import { Font } from './components/font'
import { HtmlContentStyles } from './components/htmlContentStyles'
import { NotFound } from './components/notFound'
import { useProjectId } from './hooks/useProjectId'

export const Theme = ({ children }) => {
  const projectId = useProjectId()
  const { data: project, isLoading } = useProject(projectId)

  // Block rendering while loading to prevent FOUC (flash of unstyled content).
  // The Signup component shows a spinner during this time.
  if (isLoading) return null
  if (!projectId) return children
  if (!project) return <NotFound />

  const muiThemeConfig = project.muiThemeConfig
  const themeFonts = project.themeFonts

  // Try to create theme with config, fall back to default if invalid
  let theme
  try {
    theme = createTheme(muiThemeConfig)
  } catch (error) {
    console.warn('Invalid theme configuration, using default theme:', error)
    theme = createTheme({})
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Font themeFonts={themeFonts} />
        <HtmlContentStyles />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
